import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutorizacaoGuardAsync } from './autenticacao/autorizacao.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dash'
  },
  {
    path: 'dash',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'agenda',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/agenda/agenda.module').then(m => m.AgendaModule)
  },
  {
    path: 'atendimentos-medicos',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/atendimento-medico/atendimento-medico.module').then(m => m.AtendimentoMedicoModule)
  },
  {
    path: 'exames',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/exame/exame.module').then(m => m.ExameModule)
  },
  {
    path: 'atestados-medicos',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/atestado-medico/atestado-medico.module').then(m => m.AtestadoMedicoModule)
  },
  {
    path: 'configuracoes',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/configuracao/configuracao.module').then(m => m.ConfiguracaoModule)
  },
  {
    path: 'modelos',
    canLoad: [AutorizacaoGuardAsync],
    canActivateChild: [AutorizacaoGuardAsync],
    loadChildren: () => import('src/app/modelo-geral/modelo-geral.module').then(m => m.ModeloGeralModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
